import cuid from 'cuid'
import { compose } from 'redux'

export const renewElementIdInTemplate = (template) => compose(
  normalizeElements,
  stampNewIdToElements,
  denormalizeElements
)(template.details, template.elementById)

export const stampNewIdToElements = (deNormalizedElements) => {
  // return single array
  return deNormalizedElements.reduce(
    (result, { elements, ...rest }) => {
      const newId = cuid()
      return [
        ...result,
        {
          ...rest,
          id: newId,
          ...elements && {
            elements: stampNewIdToElements(elements)
          }
        }
      ]
    }, []
  )
}

export const denormalizeElements = (details, elementById) => {
  // return single array
  return details.map((id) => {
    const { elements, ...rest } = elementById[id]
    return {
      ...rest,
      ...elements && {
        elements: denormalizeElements(elements, elementById)
      }
    }
  })
}

export const normalizeElements = (elements) => {
  const details = elements.map(({ id }) => id)
  const elementById = produceElementById(elements)
  return {
    details,
    elementById,
  }
}

const produceElementById = (elements) => {
  return elements.reduce((result, element) => {
    const { elements } = element
    return {
      ...result,
      ...modifyElement(element),
      ...elements && produceElementById(elements)
    }
  }, {})
}

const modifyElement = ({ id, elements, ...rest }) => {
  if(elements){
    return {
      [id]: {
        id,
        ...rest,
        elements: getIds(elements)
      }
    }
  }
  return { [id]: { id, ...rest }}
}
const getIds = (elements) => elements.map(({ id }) => id)

export const injectProductCardConfig = (productCardConfig) => {
  if (!productCardConfig) {
    return {
      attributeRule: [],
      attributeStyle: 'normal',
      originalPricePosition: 'top',
      hasBadge: false,
      shouldDisplayBrand: false,
    }
  }
  const {
    attributeRule,
    defaultAttributeStyle,
    defaultOriginalPricePosition,
    defaultHasBadge = false,
    brand = false,
    defaultShouldDisplayBrand = false,
  } = productCardConfig
  return {
    attributeRule,
    attributeStyle: defaultAttributeStyle,
    originalPricePosition: defaultOriginalPricePosition,
    hasBadge: defaultHasBadge,
    shouldDisplayBrand: brand && defaultShouldDisplayBrand,
  }
}


// WEBPACK FOOTER //
// ./src/helpers/elementHelpers.js